<template>
    <InputDropdownCheckboxes
        translationkey="general.choose-categories"
        v-model="filteredCategories"
        :data="categories"
        :hasSelectAllCheckbox="true"
        :icon="featureIcons.CATEGORY"
        :selectAllOptionsOnLoad
    />
</template>
<script setup lang="ts">
import { InputDropdownCheckboxes } from '@/components';
import { featureIcons } from '@/components/Menu/featureicons';
import { useEventCommonStoreRef } from '@/stores';
import { computed } from 'vue';

const props = defineProps<{
    /**
     * the ids to show in list, if not set it is all
     */
    categoryIDs?: number[];
    /**
     * If true we select all the options on load (this will naturally update the modelValue)
     */
    selectAllOptionsOnLoad?: boolean;
}>();
const filteredCategories = defineModel<number[]>({ required: true });

const categories = computed(() => {
    return Array.from(useEventCommonStoreRef().CategoriesAsSelectLine.value.values()).filter(
        (g) => !props.categoryIDs || props.categoryIDs.includes(g.value as number),
    );
});
</script>
